import InvoicingFormInfo from './InvoicingFormInfo';

export default InvoicingFormInfo;
